import QuestionShow from '../components/question/Show.vue';
import QuestionFinished from '../components/question/Finished.vue';
import QuestionZeroPool from '../components/question/ZeroPool.vue';
import auth from '../middleware/auth';

export default [
    {
        name: 'QuestionShowCurrent',
        path: '/questions/show',
        component: QuestionShow,
        meta: {
            middleware: [auth],
            title: 'global.menu.questions.continue'
        }
    },
    {
        name: 'QuestionShow',
        path: '/questions/show/:id',
        component: QuestionShow,
        meta: {
            middleware: [auth],
            title: 'global.menu.questions.continue'
        }
    },
    {
        name: 'QuestionShowByPack',
        path: '/questions/packs/:packId',
        component: QuestionShow,
        meta: {
            middleware: [auth],
            title: 'global.menu.questions.continue'
        }
    },
    {
        name: 'QuestionFinished',
        path: '/questions/finished',
        component: QuestionFinished,
        meta: {
            middleware: [auth],
            title: 'global.menu.questions.continue'
        }
    },
    {
        name: 'QuestionZeroPool',
        path: '/questions/zeroPool',
        component: QuestionZeroPool,
        props: (route) => ({...route.params}),
        meta: {
            middleware: [auth],
            title: 'global.menu.questions.continue'
        }
    },
];



// WEBPACK FOOTER //
// ./src/routes/question.js